import request from '@/assets/js/myAxios'

export async function GetMenuList(data) {
  return request({
    url: '/api/mall_UserMenu/GetMenuList',
    method: 'get',
  })
}

export async function GetPageData(data, config = {}) {
  return request({
    url: '/api/mall_Product/GetPageData',
    method: 'post',
    data,
    ...config,
  })
}

export async function SearchProducts(keyword) {
  return GetPageData({
    page: 1,
    rows: 10,
    sort: 'sellNum',
    order: 'desc',
    wheres: [
      { name: 'SEO', value: keyword, displayType: 'like' },
      { name: 'productShowPrice', value: '', displayType: 'ThanOrEqual' },
      { name: 'productShowPrice', value: '', displayType: 'LessOrequal' },
      { name: 'userMenuId', value: '' },
      { name: 'productType', value: '' },
    ],
  }, { hideLoading: true })
}

export async function GetProductDetails(data) {
  return request({
    url: '/api/mall_ProductSpec/GetProductDetails?productId='+data,
    method: 'get',
  })
}

//统计商品查看次数
export async function UpdateShowNum(data) {
  return request({
    url: '/api/mall_Product/UpdateShowNum?id='+data,
    method: 'get',
  })
}







